var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useStyles, chakra, forwardRef as forwardRef$1, useMultiStyleConfig, omitThemingProps, StylesProvider } from "@chakra-ui/system";
import { Collapse } from "@chakra-ui/transition";
import { dataAttr, cx } from "@chakra-ui/utils";
import { motion, AnimatePresence } from "framer-motion";
import * as React from "react";
import React__default from "react";
import { Flex, chakra as chakra$1, forwardRef, useStyles as useStyles$1, Spinner, useMediaQuery } from "@chakra-ui/react";
import { mode, anatomy, darken, lighten } from "@chakra-ui/theme-tools";
import { createIcon } from "@chakra-ui/icon";
const StepsContext = React.createContext({
  activeStep: 0
});
const useStepsContext = () => React.useContext(StepsContext);
const StepsProvider = ({
  value,
  children
}) => {
  const [widths, setWidths] = React.useState([]);
  const isError = value.state === "error";
  const isLoading = value.state === "loading";
  const isVertical = value.orientation === "vertical";
  const isLabelVertical = value.orientation !== "vertical" && value.labelOrientation === "vertical";
  return jsx(StepsContext.Provider, {
    value: __spreadProps(__spreadValues({}, value), {
      widths,
      setWidths,
      isError,
      isLoading,
      isVertical,
      isLabelVertical
    }),
    children
  });
};
const Connector = React.memo(({
  index,
  isCompletedStep,
  children,
  isLastStep,
  hasLabel
}) => {
  const {
    connector,
    stepIconContainer
  } = useStyles();
  const {
    isVertical,
    isLabelVertical,
    widths
  } = useStepsContext();
  const getMargin = () => {
    if (isVertical)
      return `calc(${stepIconContainer.width} / 2)`;
    if (!hasLabel)
      return 2;
    return 0;
  };
  const styles = React.useMemo(() => {
    const base = {
      ms: getMargin(),
      my: isVertical ? 2 : 0,
      ps: isVertical ? 4 : 0,
      me: isVertical || isLabelVertical ? 0 : 2,
      height: isVertical ? "auto" : "2px",
      alignSelf: isVertical ? "stretch" : "auto",
      borderTopWidth: isLastStep || isVertical ? 0 : "2px",
      borderInlineStartWidth: isLastStep || !isVertical ? 0 : "2px",
      minHeight: isLastStep || !isVertical ? "auto" : "1.5rem"
    };
    if (isLabelVertical) {
      return __spreadProps(__spreadValues({}, base), {
        position: "absolute",
        top: `calc(${stepIconContainer.height} / 2  - ${base.height} / 2)`,
        left: `calc(((${widths == null ? void 0 : widths[index]}px + ${stepIconContainer.width}) / 2) + 8px)`,
        right: `calc((${widths == null ? void 0 : widths[index + 1]}px - ${stepIconContainer.width}) / -2 + 8px)`
      });
    }
    return base;
  }, [widths, isLabelVertical, isVertical, stepIconContainer.height, stepIconContainer.width]);
  return jsx(chakra.div, {
    __css: __spreadValues(__spreadValues({}, styles), connector),
    "data-highlighted": dataAttr(isCompletedStep),
    children: isVertical && children
  });
});
const CheckIcon = createIcon({
  viewBox: "0 0 14 14",
  path: jsx("g", {
    fill: "currentColor",
    children: jsx("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    })
  })
});
const CloseIcon = createIcon({
  displayName: "CloseIcon",
  d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
});
const MotionFlex = motion(Flex);
const AnimatedCloseIcon = motion(CloseIcon);
const AnimatedSpan = motion(chakra$1.span);
const animationConfig = {
  transition: {
    duration: 0.25
  },
  exit: {
    scale: 0.5,
    opacity: 0
  },
  initial: {
    scale: 0.5,
    opacity: 0
  },
  animate: {
    scale: 1,
    opacity: 1
  }
};
const StepIcon = forwardRef((props, ref) => {
  const {
    icon,
    iconLabel,
    label
  } = useStyles$1();
  const {
    isCompletedStep,
    isCurrentStep,
    isError,
    isLoading,
    icon: CustomIcon,
    index,
    checkIcon: CustomCheckIcon
  } = props;
  const labelStyles = __spreadValues({
    fontWeight: "medium",
    color: mode(`gray.900`, `gray.100`)(props),
    textAlign: "center",
    fontSize: "md"
  }, label);
  const Icon = React__default.useMemo(() => CustomIcon ? CustomIcon : null, [CustomIcon]);
  const Check = React__default.useMemo(() => CustomCheckIcon ? CustomCheckIcon : CheckIcon, [CustomCheckIcon]);
  return React__default.useMemo(() => {
    if (isCompletedStep) {
      return jsx(MotionFlex, __spreadProps(__spreadValues({}, animationConfig), {
        children: jsx(Check, {
          color: "white",
          style: icon
        })
      }), "check-icon");
    }
    if (isCurrentStep) {
      if (isError)
        return jsx(AnimatedCloseIcon, __spreadProps(__spreadValues({
          color: "white"
        }, animationConfig), {
          style: icon
        }), "icon");
      if (isLoading)
        return jsx(Spinner, {
          width: icon.width,
          height: icon.height
        });
    }
    if (Icon)
      return jsx(MotionFlex, __spreadProps(__spreadValues({}, animationConfig), {
        children: jsx(Icon, {
          style: icon
        })
      }), "step-icon");
    return jsx(AnimatedSpan, __spreadProps(__spreadValues({
      ref,
      style: iconLabel,
      __css: labelStyles
    }, animationConfig), {
      children: (index || 0) + 1
    }), "label");
  }, [isCompletedStep, isCurrentStep, isError, isLoading, Icon, icon]);
});
const StepLabel = ({
  isCurrentStep,
  opacity,
  label,
  description
}) => {
  const {
    labelContainer,
    label: labelStyles,
    description: descriptionStyles
  } = useStyles$1();
  const {
    isLabelVertical
  } = useStepsContext();
  const shouldRender = !!label || !!description;
  return shouldRender ? jsxs(chakra$1.div, {
    "aria-current": isCurrentStep ? "step" : void 0,
    __css: __spreadValues({
      textAlign: isLabelVertical ? "center" : "left",
      alignItems: isLabelVertical ? "center" : "flex-start"
    }, labelContainer),
    children: [!!label && jsx(chakra$1.span, {
      __css: __spreadValues({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 1 : 0,
        opacity
      }, labelStyles),
      children: label
    }), !!description && jsx(chakra$1.span, {
      __css: __spreadValues({
        mx: isLabelVertical ? 0 : 2,
        mt: isLabelVertical ? 2 : 0,
        opacity
      }, descriptionStyles),
      children: description
    })]
  }) : null;
};
const Step = forwardRef$1((props, ref) => {
  const _a = props, {
    children,
    description,
    icon,
    index,
    isCompletedStep,
    isCurrentStep,
    isLastStep,
    label
  } = _a, styleProps = __objRest(_a, [
    "children",
    "description",
    "icon",
    "index",
    "isCompletedStep",
    "isCurrentStep",
    "isLastStep",
    "label"
  ]);
  const {
    isVertical,
    isError,
    isLoading,
    isLabelVertical,
    checkIcon,
    onClickStep,
    clickable,
    setWidths,
    stepCount
  } = useStepsContext();
  const {
    step,
    stepContainer,
    stepIconContainer
  } = useStyles();
  const hasVisited = isCurrentStep || isCompletedStep;
  const opacity = hasVisited ? 1 : 0.8;
  const handleClick = (index2) => {
    if (clickable && onClickStep) {
      onClickStep(index2);
    }
  };
  const containerRef = React.createRef();
  React.useEffect(() => {
    if (containerRef && containerRef.current && setWidths) {
      setWidths((prev) => {
        var _a2, _b;
        if (prev.length === stepCount) {
          return [((_a2 = containerRef.current) == null ? void 0 : _a2.offsetWidth) || 0];
        }
        return [...prev, ((_b = containerRef.current) == null ? void 0 : _b.offsetWidth) || 0];
      });
    }
  }, [stepIconContainer.width, stepIconContainer.height]);
  return jsx(Fragment, {
    children: jsxs(chakra.li, __spreadProps(__spreadValues({
      ref,
      onClick: () => handleClick(index),
      "aria-disabled": !hasVisited,
      __css: __spreadValues({
        opacity,
        flexDir: isVertical ? "column" : "row",
        alignItems: isVertical || isLabelVertical ? "flex-start" : "center",
        flex: isLastStep && !isVertical ? "0 0 auto" : "1 0 auto",
        justifyContent: isLastStep && !isVertical ? "flex-end" : "flex-start",
        _hover: {
          cursor: clickable ? "pointer" : "default"
        }
      }, step)
    }, styleProps), {
      children: [jsxs(chakra.div, {
        ref: containerRef,
        __css: __spreadValues({
          flexDir: isLabelVertical ? "column" : "row"
        }, stepContainer),
        children: [jsx(chakra.div, {
          __css: stepIconContainer,
          "aria-current": isCurrentStep ? "step" : void 0,
          "data-invalid": dataAttr(isCurrentStep && isError),
          "data-highlighted": dataAttr(isCompletedStep),
          "data-clickable": dataAttr(clickable),
          children: jsx(AnimatePresence, {
            exitBeforeEnter: true,
            children: jsx(StepIcon, __spreadProps(__spreadValues({}, {
              index,
              isError,
              isLoading,
              isCurrentStep,
              isCompletedStep
            }), {
              icon,
              checkIcon
            }))
          })
        }), jsx(StepLabel, __spreadValues({
          label,
          description
        }, {
          isCurrentStep,
          opacity
        }))]
      }), jsx(Connector, {
        index,
        isLastStep,
        hasLabel: !!label || !!description,
        isCompletedStep: isCompletedStep || false,
        children: jsx(Collapse, {
          style: {
            width: "100%"
          },
          in: isCurrentStep,
          children: (isCurrentStep || isCompletedStep) && children
        })
      })]
    }))
  });
});
const Steps = forwardRef$1((props, ref) => {
  const styles = useMultiStyleConfig("Steps", props);
  const stepsStyles = __spreadValues({}, styles.steps);
  const _a = omitThemingProps(props), {
    className,
    activeStep,
    children,
    orientation: orientationProp,
    state,
    responsive,
    checkIcon,
    onClickStep,
    labelOrientation
  } = _a, rest = __objRest(_a, [
    "className",
    "activeStep",
    "children",
    "orientation",
    "state",
    "responsive",
    "checkIcon",
    "onClickStep",
    "labelOrientation"
  ]);
  const childArr = React.Children.toArray(children);
  const stepCount = childArr.length;
  const renderHorizontalContent = () => {
    if (activeStep <= childArr.length) {
      return React.Children.map(childArr[activeStep], (node) => {
        if (!React.isValidElement(node))
          return;
        return React.Children.map(node.props.children, (childNode) => childNode);
      });
    }
    return null;
  };
  const clickable = !!onClickStep;
  const [isMobile] = useMediaQuery("(max-width: 43em)");
  const orientation = isMobile && responsive ? "vertical" : orientationProp;
  return jsx(StylesProvider, {
    value: styles,
    children: jsxs(StepsProvider, {
      value: {
        activeStep,
        orientation,
        state,
        responsive,
        checkIcon,
        onClickStep,
        labelOrientation,
        clickable,
        colorScheme: props.colorScheme,
        stepCount
      },
      children: [jsx(chakra.ol, __spreadProps(__spreadValues({
        ref,
        __css: __spreadValues({
          justifyContent: stepCount === 1 ? "flex-end" : "space-between",
          flexDir: orientation === "vertical" ? "column" : "row"
        }, stepsStyles),
        className: cx("chakra-steps", className)
      }, rest), {
        children: React.Children.map(children, (child, i) => {
          var _a2;
          const isCompletedStep = (_a2 = React.isValidElement(child) && child.props.isCompletedStep) != null ? _a2 : i < activeStep;
          const isLastStep = i === stepCount - 1;
          const isCurrentStep = i === activeStep;
          const stepProps = {
            index: i,
            isCompletedStep,
            isCurrentStep,
            isLastStep
          };
          if (React.isValidElement(child)) {
            return React.cloneElement(child, stepProps);
          }
          return null;
        })
      })), orientation === "horizontal" && renderHorizontalContent()]
    })
  });
});
Steps.defaultProps = {
  activeStep: 0,
  colorScheme: "green",
  orientation: "horizontal",
  responsive: true
};
function useSteps({ initialStep }) {
  const [activeStep, setActiveStep] = React.useState(initialStep);
  const nextStep = () => {
    setActiveStep((prev) => prev + 1);
  };
  const prevStep = () => {
    setActiveStep((prev) => prev - 1);
  };
  const reset = () => {
    setActiveStep(initialStep);
  };
  const setStep = (step) => {
    setActiveStep(step);
  };
  return { nextStep, prevStep, reset, setStep, activeStep };
}
const parts = anatomy("steps").parts("connector", "description", "icon", "iconLabel", "label", "labelContainer", "step", "stepContainer", "stepIconContainer", "steps");
const baseStyleIcon = {
  strokeWidth: "2px"
};
const baseStyleLabel = (props) => ({
  color: mode(`gray.900`, `gray.100`)(props),
  fontWeight: "medium",
  textAlign: "center",
  fontSize: "md"
});
const baseStyleDescription = (props) => ({
  color: mode(`gray.800`, `gray.200`)(props),
  marginTop: "-2px",
  textAlign: "center",
  fontSize: "sm"
});
const baseStyleConnector = (props) => {
  const { colorScheme: c } = props;
  const inactiveColor = mode("gray.200", "gray.700")(props);
  const activeColor = mode(`${c}.500`, `${c}.200`)(props);
  return {
    flex: 1,
    display: "flex",
    borderColor: inactiveColor,
    transitionProperty: "border-color",
    transitionDuration: "normal",
    _highlighted: {
      borderColor: activeColor
    }
  };
};
const baseStyleStepIconContainer = (props) => {
  const { colorScheme: c } = props;
  const inactiveColor = mode("gray.200", "gray.700")(props);
  const activeColor = `${c}.500`;
  return {
    display: "flex",
    borderRadius: "50%",
    alignItems: "center",
    justifyContent: "center",
    bg: inactiveColor,
    borderColor: inactiveColor,
    transitionProperty: "background, border-color",
    transitionDuration: "normal",
    _activeStep: {
      bg: mode(darken(inactiveColor, 0.5), lighten(inactiveColor, 0.5))(props),
      borderColor: activeColor,
      _invalid: {
        bg: "red.500",
        borderColor: "red.500"
      }
    },
    _highlighted: {
      bg: activeColor,
      borderColor: activeColor
    },
    "&[data-clickable]:hover": {
      borderColor: activeColor
    }
  };
};
const baseStyle = (props) => ({
  connector: baseStyleConnector(props),
  description: baseStyleDescription(props),
  icon: baseStyleIcon,
  iconLabel: baseStyleLabel(props),
  label: baseStyleLabel(props),
  labelContainer: {
    display: "flex",
    flexDir: "column",
    justifyContent: "center"
  },
  step: {
    display: "flex",
    position: "relative"
  },
  stepContainer: {
    display: "flex",
    alignItems: "center"
  },
  stepIconContainer: baseStyleStepIconContainer(props),
  steps: {
    fontFamily: "heading",
    textAlign: "center",
    width: "100%",
    display: "flex",
    flex: 1
  }
});
const sizes = {
  sm: {
    stepIconContainer: {
      width: "32px",
      height: "32px",
      borderWidth: "2px"
    },
    icon: {
      width: "14px",
      height: "14px"
    },
    label: {
      fontWeight: "medium",
      textAlign: "center",
      fontSize: "sm"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "xs"
    }
  },
  md: {
    stepIconContainer: {
      width: "40px",
      height: "40px",
      borderWidth: "2px"
    },
    icon: {
      width: "18px",
      height: "18px"
    },
    label: {
      fontWeight: "medium",
      textAlign: "center",
      fontSize: "md"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "sm"
    }
  },
  lg: {
    stepIconContainer: {
      width: "48px",
      height: "48px",
      borderWidth: "2px"
    },
    icon: {
      width: "22px",
      height: "22px"
    },
    label: {
      fontWeight: "bold",
      textAlign: "center",
      fontSize: "lg"
    },
    description: {
      fontWeight: "300",
      textAlign: "center",
      fontSize: "md"
    }
  }
};
const defaultProps = {
  size: "md",
  colorScheme: "green"
};
const StepsStyleConfig = {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps
};
export { Step, Steps, StepsStyleConfig, useSteps };
